module.exports = '<svg width="36" height="32" viewBox="0 0 36 32"><path d="M30 4c-1.106 0-2 .894-2 2v6c0 2.604-1.678 4.802-4 5.63V2c0-1.106-.894-2-2-2H6C4.894 0 4 .894 4 2v26H1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-3v-6.204c4.558-.928 8-4.968 8-9.796V8h2c1.106 0 2-.894 2-2s-.894-2-2-2h-4zM20 4v8H8V4h12z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/gas-1.js
// module id = 1157
// module chunks = 14